
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Select,
  Option,
  Input,
  Button,
  Row,
  Col,
  Table,
  TableColumn,
  Pagination,
  Tag,
  Loading,
  Message,
} from 'element-ui';
import api from '@/api/course';
import { AxiosResponse } from 'axios';
import type { addOJ, QuestionResponse, Question } from '@/types/assignment.d';

Vue.use(Loading.directive);

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Select,
    Option,
    Input,
    Button,
    Row,
    Col,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Message,
  },
})
export default class AddQuestionModal extends Vue {
  @Prop({ type: Object, default: () => ({}) }) oldForm!: addOJ;

  @Prop({ type: String, default: '' }) title!: string;

  @Prop({ type: Boolean, default: false }) visible!: boolean;

  form: addOJ = {
    title: '',
    type: undefined,
    chapterPid: '',
  };

  tableData: Question[] = [];

  total = 0;

  currentPage = 1;

  pageSize = 20;

  searchLoading = false;

  submitLoading = false;

  selectedRows: Question[] = [];

  existingQuestions: number[] = [];

  typeOptions = [
    { value: 0, label: '选择题' },
    { value: 1, label: '判断题' },
    { value: 2, label: '多选题' },
    { value: 3, label: '填空题' },
    { value: 4, label: '编程题' },
    { value: 5, label: '阅读程序题' },
    { value: 6, label: '问答题' },
  ];

  @Watch('visible')
  private onVisibleChange(val: boolean) {
    if (val) {
      this.tableData = [];
      this.total = 0;
      this.selectedRows = [];
      this.loadExistingQuestions();
    }
  }

  private isQuestionExists(row: Question) {
    return this.existingQuestions.includes(row.pid);
  }

  private isRowSelectable(row: Question) {
    return !this.isQuestionExists(row);
  }

  async handleSelectionChange(selection: Question[]) {
    this.selectedRows = selection;
  }

  async searchQuestion() {
    try {
      this.searchLoading = true;
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
        params: {
          title: this.form.title || undefined,
          type: this.form.type !== undefined ? this.form.type : undefined,
          questionId: this.form.pid || undefined,
        },
      };
      const res: any = await api.getQJQuestion(params);
      if (res.data) {
        this.tableData = res.data || [];
        this.total = res.total || 0;
      } else {
        Message.error('搜索失败');
      }
    } catch (error) {
      console.error('搜索失败:', error);
      Message.error('搜索失败，请重试');
    } finally {
      this.searchLoading = false;
    }
  }

  async handleSubmit() {
    if (this.selectedRows.length === 0) {
      Message.warning('请选择要添加的题目');
      return;
    }

    this.submitLoading = true;
    try {
      const courseAssignmentList = this.selectedRows.map(row => ({
        chapterPid: this.oldForm.chapterPid,
        ojQuestionPid: row.pid,
      }));

      const res: any = await api.batchAddQuestions(courseAssignmentList);

      // 显示成功消息在页面上
      Message.success('添加题目成功');

      // 清空选择
      this.selectedRows = [];

      // 重置表单
      this.resetForm();

      // 关闭模态框
      this.$emit('update:visible', false);

      // 刷新外部列表
      this.$emit('refrsh');
    } catch (error) {
      console.error('添加题目失败:', error);
      Message.error('添加题目失败，请重试');
    } finally {
      this.submitLoading = false;
    }
  }

  handleCancel() {
    this.$emit('update:visible', false);
    this.resetForm();
  }

  resetForm() {
    this.form = {
      title: '',
      type: undefined,
      chapterPid: '',
    };
    this.selectedRows = [];
  }

  handleCurrentChange(val: number) {
    this.currentPage = val;
    this.searchQuestion();
  }

  handleSizeChange(val: number) {
    this.pageSize = val;
    this.currentPage = 1;
    this.searchQuestion();
  }

  getTypeLabel(value: number | string) {
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    const option = this.typeOptions.find(item => item.value === numValue);
    const result = option ? option.label : `未知类型(${value})`;
    return result;
  }

  private async loadExistingQuestions() {
    try {
      const res: any = await api.getChapterAssignment(this.oldForm.chapterPid);
      if (res && Array.isArray(res)) {
        this.existingQuestions = res
          .map((item: any) => item.ojQuestion && item.ojQuestion.pid)
          .filter((pid: any) => pid !== undefined && pid !== null);
        console.log('已存在的题目pid列表:', this.existingQuestions);
      }
    } catch (error) {
      console.error('加载已存在题目失败:', error);
    }
  }
}
